import React, { Component } from 'react'
import { render } from "react-dom";
import Lightbox from "react-image-lightbox";
import { Camera } from 'react-feather';

import 'react-image-lightbox/style.css';
import './ImageLightbox.css'

import {
  CameraImage,
} from './ImageLightbox.css.js';

class ImageLightbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
        photoIndex: 0,
        isOpen: false
    };
  }

  render() {
    const { photoIndex, isOpen } = this.state;

    const nextSrc = (this.props.photos.length > 1) ? this.props.photos[(photoIndex + 1) % this.props.photos.length] : null;
    const prevSrc = (this.props.photos.length > 1) ? this.props.photos[(photoIndex + this.props.photos.length - 1) % this.props.photos.length] : null;

    return (
      <div className={`${this.props.styles}`}>
        <a className='ImageLightbox--Link' onClick={() => this.setState({ isOpen: true })}>
            <CameraImage src={`/images/ce-montessori/icons/camera.svg`} alt={`Camera Icon`} />
            {/* <Camera color={this.props.cameraColor} size={64} /> */}
        </a>

        {isOpen && (
          <Lightbox
            mainSrc={this.props.photos[photoIndex]}
            nextSrc={nextSrc}
            prevSrc={prevSrc}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + this.props.photos.length - 1) % this.props.photos.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % this.props.photos.length
              })
            }
          />
        )}
      </div>
    );
  }
}

export default ImageLightbox